import { CARD_TYPE } from '@jfs/ui-new/src/utils/utils'
import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { getWindow } from '../../utils'
import {
  HIDE_UPI_INTENT_FEATURE,
  MERGE_NB_CNB,
  PAYMENT_MODE_SUBTYPES,
  PAYMENT_MODE_TYPE,
  PAYMENT_TYPE,
} from '../../utils/constants'
import { RootStore } from '../store/Root'
import { Bank } from './Bank'
import { CardlessEMI } from './CardlessEMI'
import { EMI } from './EMI'
import { FoodCard } from './FoodCard'
import { PayLater } from './PayLater'
import { Subscription } from './Subscription'
import { Wallet } from './Wallet'

const removeDuplicateElement = (data: any, isSorted: boolean) => {
  const order = [
    'Jio Money',
    'Credit/Debit Card',
    'Credit Card',
    'Debit Card',
    'Saved Card',
    'Netbanking',
    'Corporate Netbanking',
    'Upi',
    'Sodexo',
    'Wallet',
    'EMI',
    'Pay Later',
  ]
  //Did this change for FIS PG. If we the payment supported value Credit Card or Debit Card then we have to show corresponding payment instead of Credit/Debit Card
  if (data.includes('Credit Card') && data.includes('Debit Card')) {
    data = data.filter((value: string) => value !== 'Credit Card' && value !== 'Debit Card')
    if (!data.includes('Credit/Debit Card')) {
      data.push('Credit/Debit Card')
    }
  }
  var retData = data.filter((value: string, index: number) => data.indexOf(value) === index && !!value)
  console.log('removeDuplicateElement retData', retData)
  if (!isSorted) {
    retData.sort(function (a: string, b: string) {
      if (order.indexOf(a) > order.indexOf(b)) {
        return 1
      }
      return -1
    })
  }
  console.log('removeDuplicateElement retData2', retData)
  return retData
}

const removeNativeUpiIfOnlyForWeb = (data: Array<string>, paymentModes: Array<string>) => {
  const isMobile = ((navigator as any)?.userAgentData?.mobile ?? false) && !!(window as any).chrome
  const isMobileSdk = getWindow().JioPaymentWebViewInterface
  let filteredArray = paymentModes
  if (RootStore?.merchant?.allowedPaymentModes?.length > 0) {
    filteredArray = RootStore?.merchant?.allowedPaymentModes
      .filter((value) => paymentModes.includes(value.methodSubType))
      .map((item) => item.methodSubType)
  } else if (RootStore?.merchant?.notAllowedPaymentModes?.length > 0) {
    const notAllowedModes = RootStore?.merchant?.notAllowedPaymentModes.map((item) => item.methodSubType)
    filteredArray = paymentModes.filter((val) => !notAllowedModes.includes(val))
  }
  if (
    !isMobile &&
    !isMobileSdk &&
    filteredArray.includes(PAYMENT_MODE_SUBTYPES.NATIVE_UPI.toString()) &&
    !filteredArray.includes(PAYMENT_MODE_SUBTYPES.UPI.toString())
  ) {
    data.splice(data.indexOf(PAYMENT_TYPE.UPI), 1)
  }
  return data
}

const AllowedCards = types.model('AllowedCards', {
  type: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  isDomesticAllowed: types.optional(types.boolean, false),
  isInternationalAllowed: types.optional(types.boolean, false),
  isPremium: types.optional(types.boolean, false),
})

const CardEMI = types.model('CardEMI', {
  emiList: types.array(EMI),
})

export const Preferences = types.model('Preferences', {
  templateId: types.optional(types.number, 0),
  defaultpaymode: types.optional(types.string, ''),
  includepaymodes: types.optional(types.string, ''),
  excludepaymodes: types.optional(types.string, ''),
  finalpaymodes: types.optional(types.string, ''),
  optedpaymodes: types.optional(types.string, ''),
  retrycount: types.optional(types.string, ''),
  cardTrustedMerchants: types.optional(types.string, ''),
  enableForCommonSavedCards: types.optional(types.string, ''),
  ssConFlag: types.optional(types.string, ''),
  uitype: types.optional(types.string, ''),
  isClickable: types.optional(types.string, ''),
  paymenttype: types.optional(types.string, ''),
  bankList: types.array(Bank),
  corpBankList: types.array(Bank),
  foodCardList: types.array(FoodCard),
  walletList: types.array(Wallet),
  cardLessEMIList: types.array(CardlessEMI),
  EMILList: types.array(EMI),
  cardEMIList: types.map(CardEMI),
  payLaterList: types.array(PayLater),
  expMon: types.optional(types.string, ''),
  expYr: types.optional(types.string, ''),
  selectedVpa: types.optional(types.string, ''),
  selectedBankId: types.optional(types.string, ''),
  upiMaxRetryLimit: types.optional(types.number, 0),
})

export const Template = types.model('Template', {
  id: types.optional(types.string, ''),
  brandColor: types.optional(types.string, ''),
  headingText: types.optional(types.string, ''),
  bodyBgColor: types.optional(types.string, ''),
  bodyTextColor: types.optional(types.string, ''),
  showBanner: types.optional(types.boolean, false),
  showStrip: types.optional(types.boolean, false),
  showCloseButton: types.optional(types.boolean, true),
  showBackButton: types.optional(types.boolean, true),
})

export const AllowedPaymentModes = types.model('AllowedPaymentModes', {
  rank: types.optional(types.string, ''),
  methodType: types.optional(types.string, ''),
  methodSubType: types.optional(types.string, ''),
  cardType: types.array(types.optional(types.number, 0)),
  bankId: types.array(types.optional(types.number, 0)),
})

export const Miscellaneous = types.model('Miscellaneous', {
  offersAllowed: types.optional(types.boolean, true),
  showSavedCards: types.optional(types.boolean, true),
})

const Merchant = types
  .model('Merchant', {
    id: types.optional(types.number, 0),
    name: types.optional(types.string, ''),
    logo: types.optional(types.string, ''),
    type: types.optional(types.enumeration('Merchant Types', ['Online', 'Offline']), 'Online'),
    submerchantId: types.optional(types.string, ''),
    subterminalId: types.optional(types.string, ''),
    partnerId: types.optional(types.string, ''),
    stcode: types.optional(types.string, ''),
    mcssName: types.optional(types.string, ''),
    mLogoName: types.optional(types.string, ''),
    sourceId: types.optional(types.string, ''),
    newSignupmids: types.optional(types.string, ''),
    secureMerchantFlag: types.optional(types.string, ''),
    useJioBalance: types.optional(types.boolean, true),
    allwcustspinpchs: types.optional(types.string, ''),
    sourceSystem: types.optional(types.string, ''),
    merchantShare: types.optional(types.string, ''),
    subscription: types.optional(Subscription, {}),
    returl: types.optional(types.string, ''),
    allowedCards: types.array(types.optional(AllowedCards, {})),
    loadMoneyAsync: types.optional(types.string, ''),
    collectLinkRequest: types.optional(types.string, ''),
    isClickable: types.optional(types.string, ''),
    mcc: types.optional(types.string, ''),
    template: types.optional(Template, {}),
    allowedPaymentConfigs: types.optional(types.string, ''),
    isAllowedPaymentModesAvailable: types.optional(types.boolean, false),
    allowedPaymentModes: types.array(types.optional(AllowedPaymentModes, {})),
    notAllowedPaymentModes: types.array(types.optional(AllowedPaymentModes, {})),
    miscellaneous: types.optional(Miscellaneous, {}),
    paymentModesSupported: types.optional(types.array(types.string), []),
    paymentsSupported: types.array(
      types.enumeration('Payment Types', [
        'Jio Money',
        'Credit/Debit Card',
        'Credit Card',
        'Debit Card',
        'Saved Card',
        'Sodexo',
        'Netbanking',
        'Upi',
        'Wallet',
        'EMI',
        'Pay Later',
        'Corporate Netbanking',
      ]),
    ),
    scPaymentsSupported: types.array(
      types.enumeration('Payment Types', [
        'Jio Money',
        'Credit/Debit Card',
        'Credit Card',
        'Debit Card',
        'Saved Card',
        'Sodexo',
        'Netbanking',
        'Upi',
        'Wallet',
      ]),
    ),
    preferences: types.optional(Preferences, {}), // part of  merchant
    vpa: types.optional(types.string, ''),
  })
  .views((self) => ({
    getPaymentModes(paymentMode: any) {
      const paymentModes = paymentMode?.filter((item: string) => {
        switch (item) {
          case String(PAYMENT_MODE_SUBTYPES.CARD):
            return String(PAYMENT_MODE_SUBTYPES.CARD)
          case String(PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION):
            return String(PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION)
          case String(PAYMENT_MODE_SUBTYPES.UPI_SUBSCRIPTION):
            return String(PAYMENT_MODE_SUBTYPES.UPI_SUBSCRIPTION)
          case String(PAYMENT_MODE_SUBTYPES.NB):
            return String(PAYMENT_MODE_SUBTYPES.NB)
          case String(PAYMENT_MODE_SUBTYPES.CORP_NB):
            return String(PAYMENT_MODE_SUBTYPES.CORP_NB)
          case String(PAYMENT_MODE_SUBTYPES.UPI):
            return String(PAYMENT_MODE_SUBTYPES.UPI)
          case String(PAYMENT_MODE_SUBTYPES.NATIVE_UPI):
            return String(PAYMENT_MODE_SUBTYPES.NATIVE_UPI)
          case String(PAYMENT_MODE_SUBTYPES.WALLET):
            return String(PAYMENT_MODE_SUBTYPES.WALLET)
          case String(PAYMENT_MODE_SUBTYPES.EMI):
            return String(PAYMENT_MODE_SUBTYPES.EMI)
          case String(PAYMENT_MODE_SUBTYPES.PAYLATER):
            return String(PAYMENT_MODE_SUBTYPES.PAYLATER)
          case String(PAYMENT_MODE_SUBTYPES.FOOD_CARD):
            return String(PAYMENT_MODE_SUBTYPES.FOOD_CARD)
          default:
            return ''
        }
      })
      return paymentModes
    },
    getPaymentModeTypes(paymentMode: any) {
      const isCreditCardAllowed = self.allowedCards.some((item) => {
        return item.type !== CARD_TYPE.DEBIT_CARD
      })
      const isDebitCardAllowed = self.allowedCards.some((item) => {
        return item.type === CARD_TYPE.DEBIT_CARD
      })
      const paymentModeTypes = paymentMode?.map((item: string) => {
        let modeName
        switch (item) {
          case String(PAYMENT_MODE_SUBTYPES.CARD):
            if (!self.subscription.isEnabled) {
              if (self.allowedPaymentModes?.length > 0) {
                const [cardPaymentMethod] = self.allowedPaymentModes?.filter((item: any) => {
                  return (
                    Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE &&
                    Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
                  )
                })

                if (cardPaymentMethod) {
                  const found = [CARD_TYPE.CREDIT_CARD, CARD_TYPE.DEBIT_CARD].every((item: any) => {
                    return cardPaymentMethod?.cardType?.includes(Number(item))
                  })
                  console.log('cardPaymentMethod isFound', found)
                  if (!found) {
                    if (cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
                      modeName = PAYMENT_TYPE.CREDIT_CARD
                      break
                    } else if (cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
                      modeName = PAYMENT_TYPE.DEBIT_CARD
                      break
                    }
                  }
                }
              } else if (self.notAllowedPaymentModes?.length > 0) {
                const [cardPaymentMethod] = self.notAllowedPaymentModes?.filter((item: any) => {
                  return (
                    Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE &&
                    Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
                  )
                })

                if (cardPaymentMethod) {
                  if (!cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
                    modeName = 'Credit Card'
                    break
                  } else if (!cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
                    modeName = 'Debit Card'
                    break
                  }
                }
              }
              if (isCreditCardAllowed && !isDebitCardAllowed) {
                modeName = 'Credit Card'
                break
              }
              if (!isCreditCardAllowed && isDebitCardAllowed) {
                modeName = 'Debit Card'
                break
              }
              modeName = PAYMENT_TYPE.CC_DC_CARD
            }
            break
          case String(PAYMENT_MODE_SUBTYPES.NB):
            modeName = PAYMENT_TYPE.NB
            break
          case String(PAYMENT_MODE_SUBTYPES.CORP_NB):
            modeName = PAYMENT_TYPE.CORP_NB
            break
          case String(PAYMENT_MODE_SUBTYPES.UPI):
            modeName = PAYMENT_TYPE.UPI
            break
          case String(PAYMENT_MODE_SUBTYPES.NATIVE_UPI):
            modeName = PAYMENT_TYPE.UPI
            break
          case String(PAYMENT_MODE_SUBTYPES.UPI_SUBSCRIPTION):
            modeName = PAYMENT_TYPE.UPI
            break
          case String(PAYMENT_MODE_SUBTYPES.WALLET):
            modeName = PAYMENT_TYPE.WALLET
            break
          case String(PAYMENT_MODE_SUBTYPES.EMI):
            modeName = PAYMENT_TYPE.EMI
            break
          case String(PAYMENT_MODE_SUBTYPES.PAYLATER):
            modeName = PAYMENT_TYPE.PAY_LATER
            break
          case String(PAYMENT_MODE_SUBTYPES.FOOD_CARD):
            modeName = PAYMENT_TYPE.SODEXO
            break
          case String(PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION):
            if (self.subscription.isEnabled) {
              if (self.allowedPaymentModes?.length > 0) {
                const [cardPaymentMethod] = self.allowedPaymentModes?.filter((item: any) => {
                  return (
                    Number(item.methodType) === PAYMENT_MODE_TYPE.SUBSCRIPTION &&
                    Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION
                  )
                })

                if (cardPaymentMethod) {
                  const found = [CARD_TYPE.CREDIT_CARD, CARD_TYPE.DEBIT_CARD].every((item: any) => {
                    return cardPaymentMethod?.cardType?.includes(Number(item))
                  })
                  console.log('cardPaymentMethod isFound', found)
                  if (!found) {
                    if (cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
                      modeName = PAYMENT_TYPE.CREDIT_CARD
                      break
                    } else if (cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
                      modeName = PAYMENT_TYPE.DEBIT_CARD
                      break
                    }
                  }
                }
              } else if (self.notAllowedPaymentModes?.length > 0) {
                const [cardPaymentMethod] = self.notAllowedPaymentModes?.filter((item: any) => {
                  return (
                    Number(item.methodType) === PAYMENT_MODE_TYPE.SUBSCRIPTION &&
                    Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION
                  )
                })

                if (cardPaymentMethod) {
                  if (!cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))) {
                    modeName = 'Credit Card'
                    break
                  } else if (!cardPaymentMethod?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD))) {
                    modeName = 'Debit Card'
                    break
                  }
                }
              }
              if (isCreditCardAllowed && !isDebitCardAllowed) {
                modeName = 'Credit Card'
                break
              }
              if (!isCreditCardAllowed && isDebitCardAllowed) {
                modeName = 'Debit Card'
                break
              }
              modeName = PAYMENT_TYPE.CC_DC_CARD
            }
            break
          default:
            modeName = null
        }
        return modeName
      })
      return paymentModeTypes
    },
    get isUpiIntentAllowed() {
      const isSubscriptionEnabled = self.subscription.isEnabled
      const isUPIIntentAllowedInConfigApi =
        self.allowedPaymentConfigs.split('|').includes('580') && !HIDE_UPI_INTENT_FEATURE
      const isUpiIntentAllowedForTnx =
        self.allowedPaymentModes.length === 0 ||
        self.allowedPaymentModes.filter(
          (item: any) => (item.methodType === '110' || item.methodType === '212') && item.methodSubType === '580',
        ).length > 0
      const isUpiIntentNotAllowedForTnx =
        self.notAllowedPaymentModes.length > 0 &&
        self.notAllowedPaymentModes.filter(
          (item: any) => (item.methodType === '110' || item.methodType === '212') && item.methodSubType === '580',
        ).length > 0
      return (
        !isSubscriptionEnabled &&
        isUPIIntentAllowedInConfigApi &&
        isUpiIntentAllowedForTnx &&
        !isUpiIntentNotAllowedForTnx
      )
    },
    get isCollectVpaSupported() {
      const isSubscriptionEnabled = self.subscription.isEnabled
      const isCollectVpaAllowedForTnx =
        self.allowedPaymentModes.length === 0 ||
        self.allowedPaymentModes.filter((item: any) => {
          return (
            (item.methodType === PAYMENT_MODE_TYPE.PURCHASE.toString() &&
              item.methodSubType === PAYMENT_MODE_SUBTYPES.UPI.toString()) ||
            (item.methodType === PAYMENT_MODE_TYPE.SUBSCRIPTION.toString() &&
              item.methodSubType === PAYMENT_MODE_SUBTYPES.UPI_SUBSCRIPTION.toString())
          )
        }).length > 0
      const iscollectVpaINNotAllowedForTnx =
        self.notAllowedPaymentModes.length > 0 &&
        self.notAllowedPaymentModes.filter((item: any) => {
          return (
            (item.methodType === PAYMENT_MODE_TYPE.PURCHASE.toString() &&
              item.methodSubType === PAYMENT_MODE_SUBTYPES.UPI.toString()) ||
            (item.methodType === PAYMENT_MODE_TYPE.SUBSCRIPTION.toString() &&
              item.methodSubType === PAYMENT_MODE_SUBTYPES.UPI_SUBSCRIPTION.toString())
          )
        }).length > 0
      return (
        ((self.paymentModesSupported.includes(PAYMENT_MODE_SUBTYPES.UPI.toString()) && !isSubscriptionEnabled) ||
          (self.paymentModesSupported.includes(PAYMENT_MODE_SUBTYPES.UPI_SUBSCRIPTION.toString()) &&
            isSubscriptionEnabled)) &&
        isCollectVpaAllowedForTnx &&
        !iscollectVpaINNotAllowedForTnx
      )
    },
    getNbType() {
      const isSubscriptionEnabled = self.subscription.isEnabled
      const isNbAllowedInConfigApi = self.allowedPaymentConfigs.split('|').includes('581')
      const isNbAllowedForTnx =
        self.allowedPaymentModes.length === 0 ||
        self.allowedPaymentModes.filter((item: any) => item.methodType === '110' && item.methodSubType === '581')
          .length > 0
      const isNbNotAllowedForTnx =
        self.notAllowedPaymentModes.length > 0 &&
        self.notAllowedPaymentModes.filter((item: any) => item.methodType === '110' && item.methodSubType === '581')
          .length > 0
      const isNbAllowed = !isSubscriptionEnabled && isNbAllowedInConfigApi && isNbAllowedForTnx && !isNbNotAllowedForTnx

      if (isNbAllowed) {
        return PAYMENT_MODE_SUBTYPES.NB
      } else {
        return PAYMENT_MODE_SUBTYPES.CORP_NB
      }
    },
  }))
  .actions((self) => ({
    updateTemplate(template: any) {
      self.template.id = template?.id ?? ''
      self.template.brandColor = template?.brandColor ?? ''
      self.template.headingText = template?.headingText ?? ''
      self.template.bodyBgColor = template?.bodyBgColor ?? ''
      self.template.bodyTextColor = template?.bodyTextColor ?? ''
      self.template.showBanner = template?.showBanner ?? false
      self.template.showStrip = template?.showStrip ?? false
      self.template.showCloseButton = template?.showCloseButton ?? true
      self.template.showBackButton = template?.showBackButton ?? true
    },
    updateAllowedPaymentModes(allowPaymentModes: any) {
      const paymentModes = allowPaymentModes?.map((item: any) => {
        return {
          rank: String(item.rank) ?? '',
          methodType: String(item.methodType) ?? '',
          methodSubType: String(item.methodSubType) ?? '',
          cardType: item.cardType ?? [],
          bankId: item.bankId ?? [],
        }
      })
      self.allowedPaymentModes = paymentModes
    },
    updateNotAllowedPaymentModes(allowPaymentModes: any) {
      const paymentModes = allowPaymentModes?.map((item: any) => {
        return {
          rank: String(item.rank) ?? '',
          methodType: String(item.methodType) ?? '',
          methodSubType: String(item.methodSubType) ?? '',
          cardType: item.cardType ?? [],
          bankId: item.bankId ?? [],
        }
      })
      self.notAllowedPaymentModes = paymentModes
    },
    updateMiscellaneous(miscellaneous: any) {
      self.miscellaneous.offersAllowed = miscellaneous?.offersAllowed ?? true
      self.miscellaneous.showSavedCards = miscellaneous?.showSavedCards ?? true
    },
    isSinglePaymentModeAllowed() {
      let isSinglePaymentAvailable = false
      if (self.allowedPaymentModes?.length === 1) {
        const [paymentMode] = self.allowedPaymentModes
        isSinglePaymentAvailable = self.paymentModesSupported?.includes(paymentMode?.methodSubType)
      } else if (self.allowedPaymentModes?.length === 2) {
        const allowedModes = self.allowedPaymentModes.map((item) => item.methodSubType)
        if (
          allowedModes.sort().toString() ===
          [PAYMENT_MODE_SUBTYPES.NATIVE_UPI, PAYMENT_MODE_SUBTYPES.UPI].sort().toString()
        ) {
          if (
            self.paymentModesSupported?.includes(allowedModes[0]) ||
            self.paymentModesSupported?.includes(allowedModes[1])
          ) {
            return true
          }
        }
        if (
          MERGE_NB_CNB &&
          allowedModes.sort().toString() === [PAYMENT_MODE_SUBTYPES.CORP_NB, PAYMENT_MODE_SUBTYPES.NB].sort().toString()
        ) {
          if (
            self.paymentModesSupported?.includes(allowedModes[0]) ||
            self.paymentModesSupported?.includes(allowedModes[1])
          ) {
            return true
          }
        }
        return false
      }
      return isSinglePaymentAvailable
    },
    isBankIdAvailable() {
      const isSinglePaymentAvailable = (self as any).isSinglePaymentModeAllowed()
      if (isSinglePaymentAvailable) {
        const paymentmode = self.allowedPaymentModes[0]
        return paymentmode.methodSubType === '581' && paymentmode.bankId.length > 0
      }
      return false
    },
    updateIsSubscriptionEnabled(isEnable: boolean) {
      self.subscription.isEnabled = isEnable
    },
    updatePaymentSupport(optedpaymodes: string): void {
      console.log('optedpaymodes::', optedpaymodes)
      if (optedpaymodes === '') {
        return
      }
      let paymentMode: any
      paymentMode = optedpaymodes.split('|')
      let isSorted = false
      self.paymentModesSupported = removeDuplicateElement(self.getPaymentModes(paymentMode), isSorted)
      const isCreditCardAllowed = self.allowedCards.some((item) => {
        return item.type !== CARD_TYPE.DEBIT_CARD
      })
      const isDebitCardAllowed = self.allowedCards.some((item) => {
        return item.type === CARD_TYPE.DEBIT_CARD
      })
      const isSubscriptionEnabled = self.subscription.isEnabled
      if (!isCreditCardAllowed && !isDebitCardAllowed) {
        self.paymentModesSupported = self.paymentModesSupported.filter((item) => {
          return (
            item !== PAYMENT_MODE_SUBTYPES.CARD.toString() &&
            item !== PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION.toString()
          )
        }) as any
      }
      paymentMode = self.paymentModesSupported
      if (self.allowedPaymentModes?.length === 0 && self.isAllowedPaymentModesAvailable) {
        paymentMode = []
      } else if (self.allowedPaymentModes?.length > 0) {
        const paymentModes = self.allowedPaymentModes.filter((paymentMode: any) => {
          return self.paymentModesSupported.some((item: any) => {
            if (
              isSubscriptionEnabled &&
              paymentMode.methodSubType === item &&
              Number(paymentMode.methodType) === PAYMENT_MODE_TYPE.SUBSCRIPTION &&
              Number(paymentMode.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION
            ) {
              return true
            } else if (
              isSubscriptionEnabled &&
              paymentMode.methodSubType === item &&
              Number(paymentMode.methodType) === PAYMENT_MODE_TYPE.SUBSCRIPTION &&
              Number(paymentMode.methodSubType) === PAYMENT_MODE_SUBTYPES.UPI_SUBSCRIPTION
            ) {
              return true
            } else if (
              !isSubscriptionEnabled &&
              (Number(paymentMode.methodType) === PAYMENT_MODE_TYPE.PURCHASE ||
                (Number(paymentMode.methodType) === PAYMENT_MODE_TYPE.UPI &&
                  paymentMode.methodSubType === PAYMENT_MODE_SUBTYPES.NATIVE_UPI.toString()))
            ) {
              if (
                paymentMode.methodSubType === item &&
                Number(paymentMode.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD &&
                !!paymentMode.cardType?.length
              ) {
                const isCheckoutAllowedDebitCard =
                  paymentMode?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD)) && isDebitCardAllowed
                const isCheckoutAllowedCreditCard =
                  paymentMode?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD)) && isCreditCardAllowed
                if (!isCheckoutAllowedDebitCard && !isCheckoutAllowedCreditCard) {
                  return false
                }
              }
              return paymentMode.methodSubType === item
            } else if (
              paymentMode.methodType === item &&
              Number(paymentMode.methodType) === PAYMENT_MODE_TYPE.EMI &&
              (Number(paymentMode.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD ||
                Number(paymentMode.methodSubType) === PAYMENT_MODE_SUBTYPES.CARDLESS_EMI)
            ) {
              return true // To Handle EMI
            } else if (paymentMode.methodType === item && Number(paymentMode.methodType) === PAYMENT_MODE_TYPE.EMI) {
              return true
            } else {
              return false
            }
          })
        })
        let sortedPaymentModes = paymentModes.sort((item1: any, item2: any) => {
          if (isNaN(Number(item1.rank))) {
            return 1
          } else if (isNaN(Number(item2.rank))) {
            return -1
          } else if (item1?.rank.trim() !== '') {
            if (item2?.rank.trim() !== '') {
              return item1.rank - item2.rank
            } else {
              return -1
            }
          } else {
            return 1
          }
        })
        paymentMode = sortedPaymentModes.map((item) => {
          if (
            Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE ||
            Number(item.methodType) === PAYMENT_MODE_TYPE.UPI ||
            (Number(item.methodType) === PAYMENT_MODE_TYPE.SUBSCRIPTION && isSubscriptionEnabled)
          ) {
            return item.methodSubType
          } else {
            return item.methodType //To Handle EMI
          }
        })
        isSorted = true
      } else if (self.notAllowedPaymentModes?.length > 0) {
        const notAllowedPaymentModes = self.notAllowedPaymentModes?.filter((item: any) => {
          if (Number(item.methodType) === PAYMENT_MODE_TYPE.EMI) {
            const emiPaymentModes = self.notAllowedPaymentModes?.filter((item: any) => {
              return Number(item.methodType) === PAYMENT_MODE_TYPE.EMI
            })
            const emiMethodSubTypes = emiPaymentModes?.map((item) => Number(item.methodSubType))
            if (
              emiMethodSubTypes?.includes(PAYMENT_MODE_SUBTYPES.CARDLESS_EMI) &&
              emiMethodSubTypes?.includes(PAYMENT_MODE_SUBTYPES.CARD)
            ) {
              const isFound = emiPaymentModes.every((item: any) => {
                if (Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD) {
                  if (item?.cardType?.length > 0) {
                    if (
                      item?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD)) &&
                      item?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))
                    ) {
                      return true
                    } else {
                      return false
                    }
                  } else {
                    return true
                  }
                } else if (Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARDLESS_EMI) {
                  return true
                } else {
                  return true
                }
              })
              return isFound
            }
            return false
          } else {
            if (
              Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD ||
              (Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD_SUBSCRIPTION && isSubscriptionEnabled)
            ) {
              if (item?.cardType?.length > 0) {
                if (
                  item?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD)) &&
                  item?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD))
                ) {
                  return true
                } else {
                  const isCheckoutAllowedDebitCard =
                    !paymentMode?.cardType?.includes(Number(CARD_TYPE.DEBIT_CARD)) && isDebitCardAllowed
                  const isCheckoutAllowedCreditCard =
                    !paymentMode?.cardType?.includes(Number(CARD_TYPE.CREDIT_CARD)) && isCreditCardAllowed
                  return !isCheckoutAllowedDebitCard && !isCheckoutAllowedCreditCard
                }
              } else {
                return true
              }
            } else if (Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.NB) {
              if (item.bankId?.length > 0) {
                return false
              } else {
                return true
              }
            } else if (Number(item) === PAYMENT_MODE_SUBTYPES.WALLET) {
              if (item.bankId?.length > 0) {
                return false
              } else {
                return true
              }
            } else if (Number(item) === PAYMENT_MODE_SUBTYPES.CORP_NB) {
              if (item.bankId?.length > 0) {
                return false
              } else {
                return true
              }
            }
            return true
          }
        })
        paymentMode = self.paymentModesSupported.filter((paymentMode: any) => {
          if (notAllowedPaymentModes?.length > 0) {
            const isFound = notAllowedPaymentModes?.some((item: any) => {
              if (
                item.methodType === paymentMode &&
                Number(item.methodType) === PAYMENT_MODE_TYPE.EMI &&
                Number(item.methodSubType) === PAYMENT_MODE_SUBTYPES.CARD
              ) {
                return true
              } else if (item.methodSubType === paymentMode && Number(item.methodType) === PAYMENT_MODE_TYPE.PURCHASE) {
                return true
              } else if (
                item.methodSubType === paymentMode &&
                Number(item.methodType) === PAYMENT_MODE_TYPE.SUBSCRIPTION
              ) {
                return true
              }
              return false
            })
            return isFound ? false : true
          }
          return true
        })
        console.log('notSupportedPaymentModes paymentMode', paymentMode)
      }

      self.paymentsSupported = removeNativeUpiIfOnlyForWeb(
        removeDuplicateElement(self.getPaymentModeTypes(paymentMode), isSorted),
        self.paymentModesSupported,
      )
    },
    updatescPaymentSupport(optedpaymodes: string[]): void {
      if (optedpaymodes?.length === 0) {
        return
      }
      const modeArray = optedpaymodes.map((item: string) => {
        let modeName
        switch (item) {
          case 'Credit Card': // For FIS PG short cash scenario
            modeName = 'Credit Card'
            break
          case 'Debit Card': // For FIS PG short cash scenario
            modeName = 'Debit Card'
            break
          case 'Net Banking': // For FIS PG short cash scenario
            modeName = 'Netbanking'
            break
          case 'Saved Cards': // For FIS PG short cash scenario
            modeName = 'Saved Card'
        }
        return modeName
      })
      console.log('modeArray', modeArray)
      self.scPaymentsSupported = removeDuplicateElement(modeArray, false)
    },
    updateMerchantData(parms: any) {
      self.id = Number(parms?.merchantId)
      self.name = parms?.merchantname
      self.logo = parms?.mLogo
      self.submerchantId = parms?.submerchantId
      self.subterminalId = parms?.subterminalId
      self.partnerId = parms?.partnerId
      self.stcode = parms?.stcode
      self.mcssName = parms?.mcssName
      self.mLogoName = parms?.mLogoName
      self.sourceId = parms?.sourceId
      self.newSignupmids = parms?.newSignupmids
      self.secureMerchantFlag = parms?.secureMerchantFlag
      self.useJioBalance = Boolean(parms?.useJioBalance ?? false)
      self.allwcustspinpchs = parms?.allwcustspinpchs
      self.sourceSystem = parms?.sourceSystem
      self.merchantShare = parms?.merchantShare
      self.returl = parms?.returl

      self.preferences.templateId = Number(parms?.templateId)
      self.preferences.includepaymodes = parms?.includepaymodes
      self.preferences.excludepaymodes = parms?.excludepaymodes
      self.preferences.finalpaymodes = parms?.finalpaymodes
      self.preferences.optedpaymodes = parms?.optedpaymodes
      self.preferences.retrycount = parms?.retrycount
      self.preferences.cardTrustedMerchants = parms?.cardTrustedMerchants
      self.preferences.enableForCommonSavedCards = parms?.enableForCommonSavedCards
      self.preferences.ssConFlag = parms?.ssConFlag
      self.preferences.uitype = parms?.uitype
      self.preferences.isClickable = parms?.isClickable
      self.preferences.expMon = parms?.expMon
      self.preferences.expYr = parms?.expYr
      self.preferences.paymenttype = parms?.paymenttype
    },
    updateMerchantId(id: number) {
      self.id = id
    },
    updateCardEmiList(card: string, emiList: any) {
      self.preferences.cardEMIList.set(card, CardEMI.create({ emiList }))
    },
    updateMaxRetryLimit(count: any) {
      self.preferences.upiMaxRetryLimit = count
    },
    getSortedAllowedPaymentModes() {
      return self?.allowedPaymentModes?.sort((item1: any, item2: any) => {
        if (isNaN(Number(item1.rank))) {
          return 1
        } else if (isNaN(Number(item2.rank))) {
          return -1
        } else if (item1?.rank.trim() !== '') {
          if (item2?.rank.trim() !== '') {
            return item1.rank - item2.rank
          } else {
            return -1
          }
        } else {
          return 1
        }
      })
    },
  }))
const MerchantInitialData = Merchant.create({
  name: '', //'Testing Merchant',
  paymentsSupported: [], // ['Jio Money', 'Credit/Debit Card', 'Saved Card', 'Netbanking', 'Upi', 'Wallet'],
  preferences: {
    templateId: 0,
    defaultpaymode: '',
    includepaymodes: '',
    excludepaymodes: '',
    finalpaymodes: '',
    optedpaymodes: '',
    retrycount: '',
    cardTrustedMerchants: '',
    enableForCommonSavedCards: '',
    ssConFlag: '',
    uitype: '',
    isClickable: '',
    paymenttype: '',
    bankList: [],
    walletList: [],
    cardLessEMIList: [],
    EMILList: [],
    payLaterList: [],
    expMon: '',
    expYr: '',
    cardEMIList: {},
    selectedVpa: '',
    selectedBankId: '',
  },
})

export type MerchantType = Instance<typeof Merchant>
export type PerformanceType = Instance<typeof Performance>
export { Merchant, MerchantInitialData }
